// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"tmSWP","route":"F8b6a","routeText":"hzS_U","routeIcon":"Dg5pF","separatorIcon":"Y31gw","homeRoute":"L8cxU","homeRouteText":"KqZ_x","homeRouteIcon":"squbw"};